import { render, staticRenderFns } from "./DataViewSidebarActes.vue?vue&type=template&id=77d6f835&scoped=true&"
import script from "./DataViewSidebarActes.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarActes.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarActes.vue?vue&type=style&index=0&id=77d6f835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d6f835",
  null
  
)

export default component.exports